export default "__VITE_ASSET__9b881157__"